import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import moment from "moment";
import {
  deleteNotifications,
  fetchNotifications,
  resendNotifications,
} from "../features/slices/notification";
import AddNotofication from "../components/notification/AddNotofication";
import { useSelector } from "react-redux";
import { toastService } from "../utils/toastify";
import CommonPagination from "../components/CommonPagination";
import DeleteModal from "../components/DeleteModal";
import { Link } from "react-router-dom";
import { canPerformAction } from "../utils/denyAccess";
const initialState = {
  fromDate: "",
  toDate: "",
  timeframe: "",
  search: "",
  page: 1,
  showDeleteModal: false,
  id: "",
};
const Notification = () => {
  const [iState, setUpdateState] = useState(initialState);
  const dispatch = useDispatch();
  const { fromDate, toDate, page, search, timeframe, showDeleteModal, id } =
    iState;
  useEffect(() => {
    dispatch(fetchNotifications({ page, timeframe }));
  }, [timeframe, page]);
  const { notifications } = useSelector((state) => {
    return state?.notification;
  });
  useEffect(() => {
    const delay = setTimeout(() => {
      dispatch(fetchNotifications({ search, timeframe }));
    }, 2000);

    return () => clearTimeout(delay); // Proper cleanup
  }, [search, dispatch, timeframe]);

  const handleResend = (id) => {
    dispatch(resendNotifications({ id })).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success(res?.payload?.message);
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const handleChange = (e) => {
    setUpdateState((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleApply = () => {
    const data = {
      search,
      fromDate,
      toDate,
      page,
    };
    dispatch(fetchNotifications(data));
  };
  const handleReset = () => {
    setUpdateState(initialState);
  };
  const handlePageChange = (page) => {
    setUpdateState((prev) => ({
      ...prev,
      page,
    }));
  };
  const handleDelete = () => {
    console.log({ id });
    dispatch(deleteNotifications({ id })).then((res) => {
      if (res?.payload?.code == 200) {
        toastService.success("notification Deleted successfully");
        setUpdateState((prev) => {
          return {
            ...prev,
            showDeleteModal: false,
            id: "",
          };
        });
        dispatch(fetchNotifications({ page }));
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      showDeleteModal: false,
    }));
  };

  return (
    <>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            {canPerformAction("Notification") && <AddNotofication />}
            <div className="TitleBox">
              <h4 className="Title">Notification History</h4>
              <div className="FilterArea">
                <div className="FilterLeft">
                  <div className="form-group">
                    <label>From</label>
                    <input
                      type="date"
                      className="form-control"
                      name="fromDate"
                      value={fromDate}
                      disabled={timeframe}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label>To</label>
                    <input
                      type="date"
                      className="form-control"
                      name="toDate"
                      value={toDate}
                      onChange={handleChange}
                      disabled={timeframe}
                    />
                  </div>
                  <div className="form-group">
                    <label>&nbsp;</label>
                    <button className="Button" onClick={handleApply}>
                      Apply
                    </button>
                  </div>
                  <div className="form-group">
                    <label>Timeframe</label>
                    <select
                      className="form-control"
                      name="timeframe"
                      onChange={handleChange}
                      disabled={fromDate || toDate}
                    >
                      <option>Select </option>
                      <option value="Today">Today</option>
                      <option value="Week">This Week</option>
                      <option value="Month">This Month</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="NewFilter">
              <div className="SearchBox">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search here by ID, Name, or Others"
                  name="search"
                  value={search}
                  onChange={handleChange}
                />
                <span>
                  <i className="fa fa-search" />
                </span>
              </div>
              <button className="Button Cancel ml-2" onClick={handleReset}>
                <i className="fa fa-refresh" />
              </button>
            </div>
            <div className="TableList">
              <table className="table-hover">
                <thead>
                  <tr>
                    <th>Sr. No</th>
                    <th>Title</th>
                    <th>Message</th>
                    <th>User Type</th>
                    <th>To User</th>
                    <th>No. of Users</th>
                    <th>Sent On</th>
                    {
                      canPerformAction("Notification") && 
                    <th>Action</th>
                    }
                  </tr>
                </thead>
                <tbody>
                  {notifications?.result?.[0]?.paginationData?.map((res, i) => {
                    return (
                      <tr>
                        <td>{i + 1 + (page - 1) * 10}</td>
                        <td>{res?.title}</td>
                        <td>{res?.content}</td>
                        <td>{res?.userType}</td>
                        <td>All</td>
                        <td>{res?.users?.length}</td>
                        <td>
                          {moment(res?.createdAt).format("DD-MM-YYYY, HH:mm")}
                        </td>
                      {
                        canPerformAction("Notification") && 
                        <td>
                          <div className="Actions">
                            <a
                              className="Black"
                              onClick={() => handleResend(res?._id)}
                            >
                              Resend
                            </a>
                            <Link to="edit" className="Edit" state={res}>
                              <i className="fa-regular fa-pen-to-square" />
                            </Link>
                            <a
                              className="Delete"
                              onClick={() => {
                                setUpdateState((prev) => ({
                                  ...prev,
                                  showDeleteModal: true,
                                  id: res?._id,
                                }));
                              }}
                            >
                              <i className="fa-regular fa-trash-can" />
                            </a>
                          </div>
                        </td>
                      }
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {notifications?.result?.[0]?.totalCount?.[0]?.count > 0 ? (
              <div className="Pagination">
                <p>
                  Showing {(page - 1) * 10 + 1} to{" "}
                  {notifications?.result?.[0]?.paginationData?.length +
                    (page - 1) * 10}{" "}
                  of {notifications?.result?.[0]?.totalCount?.[0]?.count}{" "}
                  results
                </p>
                <div className="PaginationRight">
                  {notifications?.result?.[0]?.totalCount?.[0]?.count > 0 && (
                    <CommonPagination
                      activePage={page}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        notifications?.result?.[0]?.totalCount?.[0]?.count || 0
                      }
                      pageRangeDisplayed={4}
                      onChange={handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  )}
                </div>
              </div>
            ) : (
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  background: "white",
                  height: "200px",
                  color: "green",
                }}
              >
                No Notification Yet! Please add a new Notification
              </p>
            )}
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <DeleteModal
          hanldeClose={hanldeClose}
          handleDelete={handleDelete}
          statement="notification "
        />
      )}
    </>
  );
};

export default Notification;
